import * as s from "react";
import { useCallback as A, useState as D, useEffect as X, useMemo as Qe, Children as qe } from "react";
import { Tooltip as Q } from "./tooltip.esm.f9603bda.js";
import { ObjectUtils as b, DomHandler as $, classNames as O, jsxs as x, Fragment as M, jsx as l, IconUtils as et, ZIndexUtils as ie } from "./utils.esm.ea524c19.js";
import { useUpdateEffect as tt, localeOption as G, useOverlayListener as nt, useUnmountEffect as at, Portal as rt, PrimeReact as ue } from "./portal.esm.79076359.js";
import { Dropdown as lt, InputText as ce, OverlayService as it } from "./inputtext.esm.538f495e.js";
import { CSSTransition as ut } from "./csstransition.esm.5346b5f2.js";
import { FontAwesomeIcon as ye, faXmark as ot, faMagnifyingGlass as ct } from "./index.0c001ce2.js";
function st(e) {
  if (Array.isArray(e))
    return e;
}
function dt(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], r = !0, u = !1, d, i;
    try {
      for (t = t.call(e); !(r = (d = t.next()).done) && (a.push(d.value), !(n && a.length === n)); r = !0)
        ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        !r && t.return != null && t.return();
      } finally {
        if (u)
          throw i;
      }
    }
    return a;
  }
}
function ge(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function ft(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return ge(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return ge(e, n);
  }
}
function mt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ht(e, n) {
  return st(e) || dt(e, n) || ft(e, n) || mt();
}
var q = /* @__PURE__ */ s.memo(/* @__PURE__ */ s.forwardRef(function(e, n) {
  var t = s.useState(!1), a = ht(t, 2), r = a[0], u = a[1], d = s.useRef(null), i = s.useRef(e.inputRef), f = e.checked === e.trueValue, h = function(S) {
    e.disabled || (w(S), $.focus(i.current), S.preventDefault());
  }, w = function(S) {
    if (e.onChange) {
      var R = f ? e.falseValue : e.trueValue;
      e.onChange({
        originalEvent: S,
        value: R,
        stopPropagation: function() {
        },
        preventDefault: function() {
        },
        target: {
          name: e.name,
          id: e.id,
          value: R
        }
      });
    }
  }, k = function(S) {
    u(!0), e.onFocus && e.onFocus(S);
  }, v = function(S) {
    u(!1), e.onBlur && e.onBlur(S);
  };
  s.useImperativeHandle(n, function() {
    return {
      props: e,
      getElement: function() {
        return d.current;
      },
      getInput: function() {
        return d.current;
      }
    };
  }), s.useEffect(function() {
    b.combinedRefs(i, e.inputRef);
  }, [i, e.inputRef]);
  var g = b.isNotEmpty(e.tooltip), o = b.findDiffKeys(e, q.defaultProps), c = b.reduceKeys(o, $.ARIA_PROPS), m = O("p-inputswitch p-component", {
    "p-inputswitch-checked": f,
    "p-disabled": e.disabled,
    "p-focus": r
  }, e.className);
  return /* @__PURE__ */ x(M, {
    children: [/* @__PURE__ */ x("div", {
      ref: d,
      id: e.id,
      className: m,
      style: e.style,
      ...o,
      onClick: h,
      role: "checkbox",
      "aria-checked": f,
      children: [/* @__PURE__ */ l("div", {
        className: "p-hidden-accessible",
        children: /* @__PURE__ */ l("input", {
          ref: i,
          type: "checkbox",
          id: e.inputId,
          name: e.name,
          checked: f,
          onChange: w,
          onFocus: k,
          onBlur: v,
          disabled: e.disabled,
          role: "switch",
          tabIndex: e.tabIndex,
          "aria-checked": f,
          ...c
        })
      }), /* @__PURE__ */ l("span", {
        className: "p-inputswitch-slider"
      })]
    }), g && /* @__PURE__ */ l(Q, {
      target: d,
      content: e.tooltip,
      ...e.tooltipOptions
    })]
  });
}));
q.displayName = "InputSwitch";
q.defaultProps = {
  __TYPE: "InputSwitch",
  checked: !1,
  className: null,
  disabled: !1,
  falseValue: !1,
  id: null,
  inputId: null,
  inputRef: null,
  name: null,
  onBlur: null,
  onChange: null,
  onFocus: null,
  style: null,
  tabIndex: null,
  tooltip: null,
  tooltipOptions: null,
  trueValue: !0
};
function Se({
  className: e,
  name: n,
  label: t,
  labelOnTop: a,
  help: r,
  autoFocus: u,
  value: d,
  setValue: i,
  required: f,
  invalid: h,
  invalidMessage: w,
  ...k
}) {
  const v = A(({
    value: o
  }) => i(o), [i]), g = A(() => i((o) => !o), [i]);
  return /* @__PURE__ */ x(M, {
    children: [!!t && a && /* @__PURE__ */ l("label", {
      htmlFor: n,
      className: h ? "p-error" : void 0,
      children: t + (f ? "*" : "")
    }), /* @__PURE__ */ x("div", {
      children: [/* @__PURE__ */ x("div", {
        className: `bw-input bw-input-boolean field-checkbox${e ? ` ${e}` : ""}`,
        children: [/* @__PURE__ */ l(q, {
          id: n,
          className: h ? "p-invalid" : void 0,
          checked: d || !1,
          onChange: v,
          autoFocus: u,
          required: f,
          ...k
        }), !!t && !a && /* @__PURE__ */ l("label", {
          htmlFor: n,
          className: h ? "p-error" : void 0,
          onClick: g,
          children: t + (f ? "*" : "")
        })]
      }), h && w ? /* @__PURE__ */ l("small", {
        className: "p-error",
        children: w
      }) : null, r ? /* @__PURE__ */ l("small", {
        className: "bw-input-help",
        children: r
      }) : null]
    })]
  });
}
function vt(e) {
  if (Array.isArray(e))
    return e;
}
function yt(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], r = !0, u = !1, d, i;
    try {
      for (t = t.call(e); !(r = (d = t.next()).done) && (a.push(d.value), !(n && a.length === n)); r = !0)
        ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        !r && t.return != null && t.return();
      } finally {
        if (u)
          throw i;
      }
    }
    return a;
  }
}
function be(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function gt(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return be(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return be(e, n);
  }
}
function bt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kt(e, n) {
  return vt(e) || yt(e, n) || gt(e, n) || bt();
}
var W = /* @__PURE__ */ s.memo(/* @__PURE__ */ s.forwardRef(function(e, n) {
  var t = s.useState(!1), a = kt(t, 2), r = a[0], u = a[1], d = s.useRef(null), i = s.useRef(e.inputRef), f = function(I) {
    if (!e.disabled && !e.readOnly && e.onChange) {
      var z = v(), F = I.target instanceof HTMLDivElement || I.target instanceof HTMLSpanElement, B = I.target === i.current, L = F && I.target.checked !== z;
      if (B || L) {
        var C = z ? e.falseValue : e.trueValue;
        e.onChange({
          originalEvent: I,
          value: e.value,
          checked: C,
          stopPropagation: function() {
          },
          preventDefault: function() {
          },
          target: {
            type: "checkbox",
            name: e.name,
            id: e.id,
            value: e.value,
            checked: C
          }
        });
      }
      $.focus(i.current), I.preventDefault();
    }
  }, h = function() {
    u(!0);
  }, w = function() {
    u(!1);
  }, k = function(I) {
    I.code === "Space" && f(I);
  }, v = function() {
    return e.checked === e.trueValue;
  };
  s.useImperativeHandle(n, function() {
    return {
      props: e,
      getElement: function() {
        return d.current;
      },
      getInput: function() {
        return i.current;
      }
    };
  }), s.useEffect(function() {
    b.combinedRefs(i, e.inputRef);
  }, [i, e.inputRef]), tt(function() {
    i.current.checked = v();
  }, [e.checked, e.trueValue]);
  var g = v(), o = b.isNotEmpty(e.tooltip), c = b.findDiffKeys(e, W.defaultProps), m = b.reduceKeys(c, $.ARIA_PROPS), _ = O("p-checkbox p-component", {
    "p-checkbox-checked": g,
    "p-checkbox-disabled": e.disabled,
    "p-checkbox-focused": r
  }, e.className), S = O("p-checkbox-box", {
    "p-highlight": g,
    "p-disabled": e.disabled,
    "p-focus": r
  }), R = et.getJSXIcon(g ? e.icon : "", {
    className: "p-checkbox-icon p-c"
  }, {
    props: e,
    checked: g
  });
  return /* @__PURE__ */ x(M, {
    children: [/* @__PURE__ */ x("div", {
      ref: d,
      id: e.id,
      className: _,
      style: e.style,
      ...c,
      onClick: f,
      onContextMenu: e.onContextMenu,
      onMouseDown: e.onMouseDown,
      children: [/* @__PURE__ */ l("div", {
        className: "p-hidden-accessible",
        children: /* @__PURE__ */ l("input", {
          ref: i,
          type: "checkbox",
          id: e.inputId,
          name: e.name,
          tabIndex: e.tabIndex,
          defaultChecked: g,
          onFocus: h,
          onBlur: w,
          onKeyDown: k,
          disabled: e.disabled,
          readOnly: e.readOnly,
          required: e.required,
          ...m
        })
      }), /* @__PURE__ */ l("div", {
        className: S,
        children: R
      })]
    }), o && /* @__PURE__ */ l(Q, {
      target: d,
      content: e.tooltip,
      ...e.tooltipOptions
    })]
  });
}));
W.displayName = "Checkbox";
W.defaultProps = {
  __TYPE: "Checkbox",
  id: null,
  inputRef: null,
  inputId: null,
  value: null,
  name: null,
  checked: !1,
  trueValue: !0,
  falseValue: !1,
  style: null,
  className: null,
  disabled: !1,
  required: !1,
  readOnly: !1,
  tabIndex: null,
  icon: "pi pi-check",
  tooltip: null,
  tooltipOptions: null,
  onChange: null,
  onMouseDown: null,
  onContextMenu: null
};
function Ie(e) {
  return e.choices ? /* @__PURE__ */ l(Rt, {
    ...e
  }) : /* @__PURE__ */ l(wt, {
    ...e
  });
}
const wt = ({
  className: e,
  name: n,
  label: t,
  autoFocus: a,
  value: r,
  setValue: u,
  required: d,
  invalid: i,
  invalidMessage: f,
  ...h
}) => {
  const w = A(({
    checked: v
  }) => u(v), [u]), k = n || t || "checkbox";
  return /* @__PURE__ */ x("div", {
    children: [/* @__PURE__ */ x("div", {
      className: `bw-input field-checkbox${e ? ` ${e}` : ""}`,
      children: [/* @__PURE__ */ l(W, {
        className: i ? "p-invalid" : void 0,
        name: n,
        inputId: k,
        value: r,
        checked: r || !1,
        onChange: w,
        autoFocus: a,
        required: d,
        ...h
      }), !!t && /* @__PURE__ */ l("label", {
        className: i ? "p-error" : void 0,
        htmlFor: k,
        children: t + (d ? "*" : "")
      })]
    }), i && f ? /* @__PURE__ */ l("small", {
      className: "p-error",
      children: f
    }) : null]
  });
}, Rt = ({
  className: e,
  name: n,
  label: t,
  autoFocus: a,
  value: r,
  setValue: u,
  required: d,
  invalid: i,
  invalidMessage: f,
  choices: h,
  cols: w,
  ...k
}) => {
  const [v, g] = D(r);
  X(() => {
    g((c) => c === void 0 || r === void 0 ? r : c);
  }, [r, g]);
  const o = A(({
    checked: c,
    value: m
  }) => {
    let _ = Array.isArray(r) ? [...r] : [];
    c ? _.push(m) : _ = _.filter((S) => S !== m), u([...new Set(_)]);
  }, [r, u]);
  return /* @__PURE__ */ x(M, {
    children: [t ? /* @__PURE__ */ l("label", {
      htmlFor: n,
      className: i ? "p-error" : void 0,
      children: t + (d ? "*" : "")
    }) : null, /* @__PURE__ */ x("div", {
      className: "bw-checkbox-group",
      children: [/* @__PURE__ */ l("div", {
        style: w ? {
          gridTemplateColumns: "auto ".repeat(w).trim(w)
        } : {},
        children: h.filter((c) => {
          var m;
          return !c.is_sold_out || ((m = v == null ? void 0 : v.includes) == null ? void 0 : m.call(v, c.value));
        }).map((c, m) => {
          var S;
          const _ = `${n || t}-${c.value || c.label || `checkbox-${m}`}`;
          return /* @__PURE__ */ x("div", {
            className: `bw-input field-checkbox${e ? ` ${e}` : ""}`,
            children: [/* @__PURE__ */ l(W, {
              className: i ? "p-invalid" : void 0,
              name: n,
              inputId: _,
              value: c.value,
              checked: ((S = r == null ? void 0 : r.includes) == null ? void 0 : S.call(r, c.value)) || !1,
              onChange: o,
              autoFocus: a && m === 0,
              required: d,
              ...k
            }), !!c.label && /* @__PURE__ */ l("label", {
              className: i ? "p-error" : void 0,
              htmlFor: _,
              children: c.label
            })]
          }, _);
        })
      }), i && f ? /* @__PURE__ */ l("small", {
        className: "p-error",
        children: f
      }) : null]
    })]
  });
};
function ee({
  InputClass: e,
  wrapperClassName: n,
  className: t,
  name: a,
  label: r,
  help: u,
  autoFocus: d,
  control: i,
  error: f,
  rules: h,
  value: w,
  onChange: k,
  required: v,
  invalid: g,
  invalidMessage: o,
  ...c
}) {
  return /* @__PURE__ */ x(M, {
    children: [r ? /* @__PURE__ */ l("label", {
      htmlFor: a,
      className: "bw-input-label" + (g ? " p-error" : ""),
      children: r + (v ? "*" : "")
    }) : null, /* @__PURE__ */ x("div", {
      className: `bw-input-wrapper${n ? ` ${n}` : ""}`,
      children: [/* @__PURE__ */ l(e, {
        id: a,
        name: a,
        className: `bw-input${t ? ` ${t}` : ""}${g ? " p-invalid" : ""}`,
        value: w || "",
        onChange: k,
        autoFocus: d,
        required: v,
        ...c
      }), g && o ? /* @__PURE__ */ l("small", {
        className: "p-error",
        children: o
      }) : null, u ? /* @__PURE__ */ l("small", {
        className: "bw-input-help",
        children: u
      }) : null]
    })]
  });
}
function se({
  value: e,
  setValue: n,
  choices: t,
  options: a,
  optionLabel: r = "name",
  optionValue: u = "uuid",
  optionGroupLabel: d,
  optionGroupChildren: i,
  ...f
}) {
  var v, g;
  const [h, w] = D(e);
  X(() => {
    w((o) => o === void 0 || e === void 0 ? e : o);
  }, [e, w]);
  const k = A(({
    value: o
  }) => n(o), [n]);
  return /* @__PURE__ */ l(ee, {
    InputClass: lt,
    value: e,
    onChange: k,
    options: (g = (v = t || a) == null ? void 0 : v.filter) == null ? void 0 : g.call(v, (o) => !(o != null && o.is_sold_out) || h === (o == null ? void 0 : o[t ? "value" : u])),
    optionLabel: t ? "label" : r,
    optionValue: t ? "value" : u,
    optionGroupLabel: d,
    optionGroupChildren: i,
    ...f
  });
}
function St(e) {
  if (Array.isArray(e))
    return e;
}
function It(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], r = !0, u = !1, d, i;
    try {
      for (t = t.call(e); !(r = (d = t.next()).done) && (a.push(d.value), !(n && a.length === n)); r = !0)
        ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        !r && t.return != null && t.return();
      } finally {
        if (u)
          throw i;
      }
    }
    return a;
  }
}
function ke(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function _t(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return ke(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return ke(e, n);
  }
}
function xt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y(e, n) {
  return St(e) || It(e, n) || _t(e, n) || xt();
}
var te = /* @__PURE__ */ s.memo(/* @__PURE__ */ s.forwardRef(function(e, n) {
  var t = e.promptLabel || G("passwordPrompt"), a = e.weakLabel || G("weak"), r = e.mediumLabel || G("medium"), u = e.strongLabel || G("strong"), d = s.useState(!1), i = Y(d, 2), f = i[0], h = i[1], w = s.useState(null), k = Y(w, 2), v = k[0], g = k[1], o = s.useState(t), c = Y(o, 2), m = c[0], _ = c[1], S = s.useState(!1), R = Y(S, 2), E = R[0], I = R[1], z = s.useState(!1), F = Y(z, 2), B = F[0], L = F[1], C = s.useRef(null), p = s.useRef(null), T = s.useRef(e.inputRef), H = s.useRef(new RegExp(e.mediumRegex)), V = s.useRef(new RegExp(e.strongRegex)), J = B ? "text" : "password", Z = nt({
    target: C,
    overlay: p,
    listener: function(y, P) {
      var K = P.valid;
      K && ve();
    },
    when: f
  }), de = Y(Z, 2), Ee = de[0], $e = de[1], fe = T.current && T.current.value, le = s.useMemo(function() {
    return b.isNotEmpty(e.value) || b.isNotEmpty(e.defaultValue) || b.isNotEmpty(fe);
  }, [e.value, e.defaultValue, fe]), pe = function() {
    if (v) {
      var y = null;
      switch (v.strength) {
        case "weak":
          y = a;
          break;
        case "medium":
          y = r;
          break;
        case "strong":
          y = u;
          break;
      }
      y && m !== y && _(y);
    } else
      m !== t && _(t);
  }, Te = function(y) {
    e.feedback && it.emit("overlay-click", {
      originalEvent: y,
      target: C.current
    });
  }, me = function() {
    L(function(y) {
      return !y;
    });
  }, he = function() {
    pe(), h(!0);
  }, ve = function() {
    h(!1);
  }, Pe = function() {
    T.current && $.alignOverlay(p.current, T.current.parentElement, e.appendTo || ue.appendTo);
  }, Fe = function() {
    ie.set("overlay", p.current, ue.autoZIndex, ue.zIndex.overlay), Pe();
  }, Oe = function() {
    Ee(), e.onShow && e.onShow();
  }, Ae = function() {
    $e();
  }, ze = function() {
    ie.clear(p.current), e.onHide && e.onHide();
  }, Le = function(y) {
    I(!0), e.feedback && he(), e.onFocus && e.onFocus(y);
  }, De = function(y) {
    I(!1), e.feedback && ve(), e.onBlur && e.onBlur(y);
  }, Me = function(y) {
    var P = y.keyCode || y.which;
    if (e.feedback) {
      var K = y.target.value, U = null, j = null;
      switch (Ke(K)) {
        case 1:
          U = a, j = {
            strength: "weak",
            width: "33.33%"
          };
          break;
        case 2:
          U = r, j = {
            strength: "medium",
            width: "66.66%"
          };
          break;
        case 3:
          U = u, j = {
            strength: "strong",
            width: "100%"
          };
          break;
        default:
          U = t, j = null;
          break;
      }
      g(j), _(U), !!P && !f && he();
    }
    e.onKeyUp && e.onKeyUp(y);
  }, Be = function(y, P) {
    e.onInput && e.onInput(y, P), e.onChange || (b.isNotEmpty(y.target.value) ? $.addClass(C.current, "p-inputwrapper-filled") : $.removeClass(C.current, "p-inputwrapper-filled"));
  }, Ke = function(y) {
    return V.current.test(y) ? 3 : H.current.test(y) ? 2 : y.length ? 1 : 0;
  };
  s.useImperativeHandle(n, function() {
    return {
      props: e,
      getElement: function() {
        return C.current;
      },
      getOverlay: function() {
        return p.current;
      },
      getInput: function() {
        return T.current;
      }
    };
  }), s.useEffect(function() {
    b.combinedRefs(T, e.inputRef);
  }, [T, e.inputRef]), s.useEffect(function() {
    H.current = new RegExp(e.mediumRegex);
  }, [e.mediumRegex]), s.useEffect(function() {
    V.current = new RegExp(e.strongRegex);
  }, [e.strongRegex]), s.useEffect(function() {
    !le && $.hasClass(C.current, "p-inputwrapper-filled") && $.removeClass(C.current, "p-inputwrapper-filled");
  }, [le]), at(function() {
    ie.clear(p.current);
  });
  var He = function() {
    if (e.toggleMask) {
      var y = B ? "pi pi-eye-slash" : "pi pi-eye", P = /* @__PURE__ */ l("i", {
        className: y,
        onClick: me
      });
      if (e.icon) {
        var K = {
          onClick: me,
          className: y,
          element: P,
          props: e
        };
        P = b.getJSXElement(e.icon, K);
      }
      return P;
    }
    return null;
  }, Ue = function() {
    var y = O("p-password-panel p-component", e.panelClassName), P = v || {
      strength: "",
      width: "0%"
    }, K = P.strength, U = P.width, j = b.getJSXElement(e.header, e), Ze = b.getJSXElement(e.footer, e), We = e.content ? b.getJSXElement(e.content, e) : /* @__PURE__ */ x(M, {
      children: [/* @__PURE__ */ l("div", {
        className: "p-password-meter",
        children: /* @__PURE__ */ l("div", {
          className: "p-password-strength ".concat(K),
          style: {
            width: U
          }
        })
      }), /* @__PURE__ */ l("div", {
        className: "p-password-info ".concat(K),
        children: m
      })]
    }), Ge = /* @__PURE__ */ l(ut, {
      nodeRef: p,
      classNames: "p-connected-overlay",
      in: f,
      timeout: {
        enter: 120,
        exit: 100
      },
      options: e.transitionOptions,
      unmountOnExit: !0,
      onEnter: Fe,
      onEntered: Oe,
      onExit: Ae,
      onExited: ze,
      children: /* @__PURE__ */ x("div", {
        ref: p,
        className: y,
        style: e.panelStyle,
        onClick: Te,
        children: [j, We, Ze]
      })
    });
    return /* @__PURE__ */ l(rt, {
      element: Ge,
      appendTo: e.appendTo
    });
  }, je = O("p-password p-component p-inputwrapper", {
    "p-inputwrapper-filled": le,
    "p-inputwrapper-focus": E,
    "p-input-icon-right": e.toggleMask
  }, e.className), Ve = O("p-password-input", e.inputClassName), Ye = b.findDiffKeys(e, te.defaultProps), Xe = He(), Je = Ue();
  return /* @__PURE__ */ x("div", {
    ref: C,
    id: e.id,
    className: je,
    style: e.style,
    children: [/* @__PURE__ */ l(ce, {
      ref: T,
      id: e.inputId,
      ...Ye,
      type: J,
      className: Ve,
      style: e.inputStyle,
      onFocus: Le,
      onBlur: De,
      onKeyUp: Me,
      onInput: Be,
      tooltip: e.tooltip,
      tooltipOptions: e.tooltipOptions
    }), Xe, Je]
  });
}));
te.displayName = "Password";
te.defaultProps = {
  __TYPE: "Password",
  id: null,
  inputId: null,
  inputRef: null,
  promptLabel: null,
  weakLabel: null,
  mediumLabel: null,
  strongLabel: null,
  mediumRegex: "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})",
  strongRegex: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})",
  feedback: !0,
  toggleMask: !1,
  appendTo: null,
  header: null,
  content: null,
  footer: null,
  icon: null,
  tooltip: null,
  tooltipOptions: null,
  style: null,
  className: null,
  inputStyle: null,
  inputClassName: null,
  panelStyle: null,
  panelClassName: null,
  transitionOptions: null,
  onInput: null,
  onShow: null,
  onHide: null
};
function _e({
  setValue: e,
  ...n
}) {
  const t = A(({
    target: {
      value: a
    }
  }) => e(a), [e]);
  return /* @__PURE__ */ l(ee, {
    InputClass: te,
    onChange: t,
    ...n
  });
}
function Nt(e) {
  if (Array.isArray(e))
    return e;
}
function Ct(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], r = !0, u = !1, d, i;
    try {
      for (t = t.call(e); !(r = (d = t.next()).done) && (a.push(d.value), !(n && a.length === n)); r = !0)
        ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        !r && t.return != null && t.return();
      } finally {
        if (u)
          throw i;
      }
    }
    return a;
  }
}
function we(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function Et(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return we(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return we(e, n);
  }
}
function $t() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pt(e, n) {
  return Nt(e) || Ct(e, n) || Et(e, n) || $t();
}
var ne = /* @__PURE__ */ s.memo(/* @__PURE__ */ s.forwardRef(function(e, n) {
  var t = s.useState(!1), a = pt(t, 2), r = a[0], u = a[1], d = s.useRef(null), i = s.useRef(e.inputRef), f = function(R) {
    h(R);
  }, h = function(R) {
    if (!e.disabled && e.onChange) {
      var E = e.checked, I = R.target instanceof HTMLDivElement, z = R.target === i.current, F = z && R.target.checked !== E, B = I && !R.target.checked;
      if (F || B) {
        var L = !E;
        e.onChange({
          originalEvent: R,
          value: e.value,
          checked: L,
          stopPropagation: function() {
          },
          preventDefault: function() {
          },
          target: {
            type: "radio",
            name: e.name,
            id: e.id,
            value: e.value,
            checked: L
          }
        });
      }
      $.focus(i.current), R.preventDefault();
    }
  }, w = function() {
    u(!0);
  }, k = function() {
    u(!1);
  }, v = function(R) {
    R.code === "Space" && h(R);
  };
  s.useEffect(function() {
    i.current && (i.current.checked = e.checked);
  }, [e.checked]), s.useEffect(function() {
    b.combinedRefs(i, e.inputRef);
  }, [i, e.inputRef]), s.useImperativeHandle(n, function() {
    return {
      props: e,
      select: f,
      getElement: function() {
        return d.current;
      },
      getInput: function() {
        return i.current;
      }
    };
  });
  var g = b.isNotEmpty(e.tooltip), o = b.findDiffKeys(e, ne.defaultProps), c = b.reduceKeys(o, $.ARIA_PROPS), m = O("p-radiobutton p-component", {
    "p-radiobutton-checked": e.checked,
    "p-radiobutton-disabled": e.disabled,
    "p-radiobutton-focused": r
  }, e.className), _ = O("p-radiobutton-box", {
    "p-highlight": e.checked,
    "p-disabled": e.disabled,
    "p-focus": r
  });
  return /* @__PURE__ */ x(M, {
    children: [/* @__PURE__ */ x("div", {
      ref: d,
      id: e.id,
      className: m,
      style: e.style,
      ...o,
      onClick: h,
      children: [/* @__PURE__ */ l("div", {
        className: "p-hidden-accessible",
        children: /* @__PURE__ */ l("input", {
          ref: i,
          id: e.inputId,
          type: "radio",
          name: e.name,
          defaultChecked: e.checked,
          onFocus: w,
          onBlur: k,
          onKeyDown: v,
          disabled: e.disabled,
          required: e.required,
          tabIndex: e.tabIndex,
          ...c
        })
      }), /* @__PURE__ */ l("div", {
        className: _,
        children: /* @__PURE__ */ l("div", {
          className: "p-radiobutton-icon"
        })
      })]
    }), g && /* @__PURE__ */ l(Q, {
      target: d,
      content: e.tooltip,
      ...e.tooltipOptions
    })]
  });
}));
ne.displayName = "RadioButton";
ne.defaultProps = {
  __TYPE: "RadioButton",
  id: null,
  inputRef: null,
  inputId: null,
  name: null,
  value: null,
  checked: !1,
  style: null,
  className: null,
  disabled: !1,
  required: !1,
  tabIndex: null,
  tooltip: null,
  tooltipOptions: null,
  onChange: null
};
function xe({
  className: e,
  name: n,
  label: t,
  autoFocus: a,
  value: r,
  setValue: u,
  required: d,
  invalid: i,
  invalidMessage: f,
  choices: h,
  ...w
}) {
  const [k, v] = D(r);
  X(() => {
    v((o) => o === void 0 || r === void 0 ? r : o);
  }, [r, v]);
  const g = A(({
    value: o
  }) => u(o), [u]);
  return /* @__PURE__ */ x(M, {
    children: [t ? /* @__PURE__ */ l("label", {
      htmlFor: n,
      className: i ? "p-error" : void 0,
      children: t + (d ? "*" : "")
    }) : null, /* @__PURE__ */ x("div", {
      children: [h.filter((o) => !o.is_sold_out || k === o.value).map((o, c) => {
        const m = `${n || t}-${o.value || o.label || `radiobutton-${c}`}`;
        return /* @__PURE__ */ x("div", {
          className: `bw-input field-radiobutton${e ? ` ${e}` : ""}`,
          children: [/* @__PURE__ */ l(ne, {
            className: i ? "p-invalid" : void 0,
            name: n,
            inputId: m,
            value: o.value,
            checked: r === o.value || !1,
            onChange: g,
            autoFocus: a && c === 0,
            required: d,
            ...w
          }), !!o.label && /* @__PURE__ */ l("label", {
            className: i ? "p-error" : void 0,
            htmlFor: m,
            children: o.label
          })]
        }, m);
      }), i && f ? /* @__PURE__ */ l("small", {
        className: "p-error",
        children: f
      }) : null]
    })]
  });
}
var ae = /* @__PURE__ */ s.memo(/* @__PURE__ */ s.forwardRef(function(e, n) {
  var t = s.useRef(null), a = b.findDiffKeys(e, ae.defaultProps), r = e.size ? {
    width: e.size,
    height: e.size,
    borderRadius: e.borderRadius
  } : {
    width: e.width,
    height: e.height,
    borderRadius: e.borderRadius
  }, u = O("p-skeleton p-component", {
    "p-skeleton-circle": e.shape === "circle",
    "p-skeleton-none": e.animation === "none"
  }, e.className);
  return s.useImperativeHandle(n, function() {
    return {
      props: e,
      getElement: function() {
        return t.current;
      }
    };
  }), /* @__PURE__ */ l("div", {
    ref: t,
    style: r,
    className: u,
    ...a
  });
}));
ae.displayName = "Skeleton";
ae.defaultProps = {
  __TYPE: "Skeleton",
  shape: "rectangle",
  size: null,
  width: "100%",
  height: "1rem",
  borderRadius: null,
  animation: "wave",
  style: null,
  className: null
};
function Ne({
  api: e,
  path: n,
  query: t,
  ...a
}) {
  const [u, d] = D(), [i, f] = D(""), [h, w] = D(""), [k, v] = D(""), [g, o] = D(!0), [c, m] = D({
    first: 0,
    last: 0,
    filter: ""
  });
  X(d, [n, t, d]), X(() => {
    if (h === i && u && !u.slice(c.first, c.last).some((I) => !I))
      return;
    let R = !1;
    const E = () => {
      o(!0);
      let I = Math.floor((c == null ? void 0 : c.first) / 50) + 1;
      const z = h !== i || !(u != null && u[c.first]);
      let F = Math.floor((c == null ? void 0 : c.last) / 50) + 1;
      const B = (!z || I !== F) && (h !== i || !(u != null && u[c.last]));
      Promise.all([
        z && e(`${n}?page=${I}&page_size=${50}${t ? `&${t}` : ""}${h ? `&search=${h}` : ""}`) || {},
        B && e(`${n}?page=${F}&page_size=${50}${t ? `&${t}` : ""}${h ? `&search=${h}` : ""}`) || {}
      ]).then(([{
        ok: L,
        body: C
      }, {
        ok: p,
        body: T
      }]) => {
        R || ((L || p) && (d((H) => {
          const V = h === i && (H == null ? void 0 : H.length) === (C || T).data_size ? [...H] : Array.from({
            length: (C || T).data_size
          });
          return L && (I = C.page, C.data.forEach((J, Z) => {
            V[Z + (I - 1) * 50] = J;
          })), p && (F = T.page, T.data.forEach((J, Z) => {
            V[Z + (F - 1) * 50] = J;
          })), V;
        }), f(h)), o(!1));
      });
    };
    if (u) {
      const I = setTimeout(E, 100);
      return () => {
        clearTimeout(I), R = !0;
      };
    }
    E();
  }, [e, n, t, c.first, c.last, h, u, d, i, f]);
  const _ = A(() => /* @__PURE__ */ x("div", {
    className: "p-dropdown-filter-container",
    children: [/* @__PURE__ */ l(ce, {
      className: "bw-input p-dropdown-filter",
      value: k,
      onChange: ({
        target: {
          value: I
        }
      }) => v(I)
    }), k ? /* @__PURE__ */ l(ye, {
      className: "cursor-pointer",
      title: "Clear",
      icon: ot,
      onClick: () => v("")
    }) : /* @__PURE__ */ l(ye, {
      icon: ct
    })]
  }), [k, v]);
  X(() => {
    const R = setTimeout(() => {
      w(k);
    }, 400);
    return () => clearTimeout(R);
  }, [k]);
  const S = Qe(() => u != null && u.length ? {
    lazy: !0,
    onLazyLoad: m,
    itemSize: 38,
    scrollHeight: "380px",
    numToleratedItems: 5,
    showLoader: !0,
    loading: g,
    loadingTemplate: (R) => /* @__PURE__ */ l("div", {
      className: "flex align-items-center p-2",
      style: {
        height: "38px"
      },
      children: /* @__PURE__ */ l(ae, {
        width: R.even ? "80%" : "60%",
        height: "1rem"
      })
    })
  } : void 0, [u, g, m]);
  return /* @__PURE__ */ l(se, {
    ...a,
    emptyMessage: g ? "Loading..." : h ? a.emptyFilterMessage || "Your search did not match any options" : a.emptyMessage,
    emptyFilterMessage: a.emptyFilterMessage || "Your search did not match any options",
    options: u,
    filterTemplate: _,
    virtualScrollerOptions: S
  });
}
function oe({
  setValue: e,
  ...n
}) {
  const t = A(({
    target: {
      value: a
    }
  }) => e(a), [e]);
  return /* @__PURE__ */ l(ee, {
    InputClass: ce,
    onChange: t,
    ...n
  });
}
var re = /* @__PURE__ */ s.memo(/* @__PURE__ */ s.forwardRef(function(e, n) {
  var t = s.useRef(n), a = s.useRef(0), r = function(c) {
    e.autoResize && f(), e.onFocus && e.onFocus(c);
  }, u = function(c) {
    e.autoResize && f(), e.onBlur && e.onBlur(c);
  }, d = function(c) {
    e.autoResize && f(), e.onKeyUp && e.onKeyUp(c);
  }, i = function(c) {
    e.autoResize && f(), e.onInput && e.onInput(c);
    var m = c.target;
    b.isNotEmpty(m.value) ? $.addClass(m, "p-filled") : $.removeClass(m, "p-filled");
  }, f = function(c) {
    var m = t.current;
    m && $.isVisible(m) && (a.current || (a.current = m.scrollHeight, m.style.overflow = "hidden"), (a.current !== m.scrollHeight || c) && (m.style.height = "", m.style.height = m.scrollHeight + "px", parseFloat(m.style.height) >= parseFloat(m.style.maxHeight) ? (m.style.overflowY = "scroll", m.style.height = m.style.maxHeight) : m.style.overflow = "hidden", a.current = m.scrollHeight));
  }, h = t.current && t.current.value, w = s.useMemo(function() {
    return b.isNotEmpty(e.value) || b.isNotEmpty(e.defaultValue) || b.isNotEmpty(h);
  }, [e.value, e.defaultValue, h]);
  s.useEffect(function() {
    b.combinedRefs(t, n);
  }, [t, n]), s.useEffect(function() {
    e.autoResize && f(!0);
  }, [e.autoResize]);
  var k = b.isNotEmpty(e.tooltip), v = b.findDiffKeys(e, re.defaultProps), g = O("p-inputtextarea p-inputtext p-component", {
    "p-disabled": e.disabled,
    "p-filled": w,
    "p-inputtextarea-resizable": e.autoResize
  }, e.className);
  return /* @__PURE__ */ x(M, {
    children: [/* @__PURE__ */ l("textarea", {
      ref: t,
      ...v,
      className: g,
      onFocus: r,
      onBlur: u,
      onKeyUp: d,
      onInput: i
    }), k && /* @__PURE__ */ l(Q, {
      target: t,
      content: e.tooltip,
      ...e.tooltipOptions
    })]
  });
}));
re.displayName = "InputTextarea";
re.defaultProps = {
  __TYPE: "InputTextarea",
  autoResize: !1,
  tooltip: null,
  tooltipOptions: null,
  onInput: null
};
function Ce({
  setValue: e,
  autoResize: n = !0,
  ...t
}) {
  const a = A(({
    target: {
      value: r
    }
  }) => e(r), [e]);
  return /* @__PURE__ */ l(ee, {
    InputClass: re,
    onChange: a,
    autoResize: n,
    ...t
  });
}
function Tt({
  children: e,
  className: n,
  cols: t = 1,
  horizontal: a = !1
}) {
  const r = Number.isInteger(12 / t) ? 12 / t : 12;
  return /* @__PURE__ */ l("div", {
    className: `${a ? "bw-form-horizontal" : "bw-form"} p-fluid${r !== 12 ? " grid formgrid" : ""}${n ? ` ${n}` : ""}`,
    children: qe.map(e, (u) => /* @__PURE__ */ l("div", {
      className: `field${r !== 12 ? ` col-12 md:col-${r}` : ""}`,
      children: u
    }))
  });
}
const Re = (e) => {
  switch (e.type) {
    case "text":
      return /* @__PURE__ */ l(oe, {
        ...e
      });
    case "textarea":
      return /* @__PURE__ */ l(Ce, {
        ...e
      });
    case "boolean":
      return /* @__PURE__ */ l(Se, {
        ...e
      });
    case "checkbox":
      return /* @__PURE__ */ l(Ie, {
        ...e
      });
    case "dropdown":
      return /* @__PURE__ */ l(se, {
        ...e
      });
    case "radio":
      return /* @__PURE__ */ l(xe, {
        ...e
      });
    case "password":
      return /* @__PURE__ */ l(_e, {
        ...e
      });
    case "search":
      return /* @__PURE__ */ l(Ne, {
        ...e
      });
    case "upload":
      return "NOT IMPLEMENTED";
    default:
      return e.type && console.error(`"${e.type}" is not a valid field type.`), /* @__PURE__ */ l(oe, {
        ...e
      });
  }
}, Mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FieldBoolean: Se,
  FieldCheckbox: Ie,
  FieldDropdown: se,
  FieldPassword: _e,
  FieldRadio: xe,
  FieldSearch: Ne,
  FieldText: oe,
  FieldTextarea: Ce,
  Form: Tt,
  Field: Re,
  default: Re
}, Symbol.toStringTag, { value: "Module" }));
export {
  Re as Field,
  Se as FieldBoolean,
  Ie as FieldCheckbox,
  se as FieldDropdown,
  _e as FieldPassword,
  xe as FieldRadio,
  Ne as FieldSearch,
  oe as FieldText,
  Ce as FieldTextarea,
  Tt as Form,
  Mt as index
};
